<template lang="pug">

div

    //- Navigation
    navigation

    //- Headline
    //- .ui.attached.segment
    //-     .ui.two.column.centered.middle.aligned.grid
    //-         .column
    //-             h2.ui.header
    //-                 i.users.icon
    //-                 .content Benutzer
    //-         .ui.form.column
    //-             input(type='text' placeholder='Ihr Suchbegriff')

    //- Status-Filter
    .ui.secondary
        filter-bar(v-bind:counts='counts')

    //- Message wenn keine Benutzer gefunden
    .ui.bottom.icon.message.no-users(v-if='userModels.length === 0')
        i.meh.icon
        .content: .header Keine Benutzer gefunden

    template(v-else)

        //- Benutzer
        users-table.ui.segment(
            v-bind:company-models='companyModels'
            v-bind:person-models='personModels'
            v-bind:user-models='userModels'
        )

        //- Pagination
        .ui.bottom.secondary
            .ui.two.column.grid
                .middle.aligned.column
                    .ui.form
                        .inline.fields(style='margin: 0')
                            label Zeilen pro Seite:
                            .field
                                select.ui.selection.dropdown(ref='pageSizeDropdown')
                                    option(v-for='n in pageSizeOptions' v-bind:key='n' v-bind:value='n') {{ n }}
                .right.aligned.middle.aligned.column(v-if='totalPages > 1')
                    .ui.pagination.menu
                        a.icon.item(v-bind:class='{ disabled: currentPage === 1 }' v-on:click='currentPage > 1 && (currentPage -= 1)')
                            i.left.chevron.icon
                        a.item(
                            v-for='page in totalPages'
                            v-bind:key='page'
                            v-bind:class='{ active: page === currentPage }'
                            v-on:click='currentPage = page'
                        ) {{ page }}
                        a.icon.item(v-bind:class='{ disabled: currentPage === totalPages }' v-on:click='currentPage < totalPages && (currentPage += 1)')
                            i.right.chevron.icon

</template>

<script>
    import store from '@/store'
    import FilterBar from '@/components/users/FilterBar.vue'
    import Navigation from '@/components/users/Navigation.vue'
    import UsersTable from '@/components/users/Table.vue'

    async function load_page(route, { page = 0, size = 20 } = {}) {
        const status  = route.query.status  || null
        const company = route.query.company ? Number(route.query.company) : null

        const { users, total } = await store.dispatch('users/loadPage', { page, size, status, company })

        // Personen parallel laden
        const persons = await Promise.all(users.map(u => store.dispatch('persons/loadOne', { id: u.person })))

        // Unternehmen laden — dedupliziert, gecacht wenn mehrere User vom selben Unternehmen
        const companyIds = [...new Set(persons.filter(Boolean).map(p => p.company).filter(Boolean))]
        await Promise.all(companyIds.map(id => store.dispatch('companies/loadOne', { id })))

        return { users, total }
    }

    //noinspection JSUnusedLocalSymbols,JSUnusedGlobalSymbols
    export default {

        components: { FilterBar, Navigation, UsersTable },

        beforeRouteEnter(to, from, next) {
            load_page(to).then(({ users, total }) => next(vm => {
                vm.pageUsers    = users
                vm.filteredTotal = total
            }))
        },

        beforeRouteUpdate(to, from, next) {
            this._routeChanging = true
            this.currentPage = 1
            load_page(to, { page: 0, size: this.itemsPerPage })
                .then(({ users, total }) => {
                    this.pageUsers     = users
                    this.filteredTotal = total
                    this._routeChanging = false
                    next()
                })
        },

        created() {
            this._routeChanging = false
        },

        mounted() {
            this._initDropdown()
        },

        updated() {
            this._initDropdown()
        },

        data() {
            return {
                currentPage:   1,
                filteredTotal: 0,
                itemsPerPage:  25,
                pageUsers:     [],
                pageSizeOptions: [25, 50, 100, 250],
            }
        },

        watch: {
            currentPage() {
                if (!this._routeChanging) {
                    this.loadCurrentPage()
                }
            },
            itemsPerPage() {
                if (this.currentPage === 1) {
                    this.loadCurrentPage()
                } else {
                    this.currentPage = 1
                }
            },
        },

        methods: {
            _initDropdown() {
                const el = this.$refs.pageSizeDropdown
                if (!el || $(el).data('module-dropdown')) return
                $(el).dropdown({
                    onChange: (value) => {
                        const n = parseInt(value, 10)
                        if (n !== this.itemsPerPage) {
                            this.itemsPerPage = n
                            this.currentPage = 1
                        }
                    }
                })
            },

            async loadCurrentPage() {
                const { users, total } = await load_page(this.$route, {
                    page: this.currentPage - 1,
                    size: this.itemsPerPage,
                })
                this.pageUsers     = users
                this.filteredTotal = total
            }
        },

        computed: {

            counts() {
                return this.$store.state.users.counts
            },

            companyModels() {
                return store.getters['companies/all']
            },

            personModels() {
                return store.getters['persons/all']
            },

            userModels() {
                return this.pageUsers
            },

            totalPages() {
                return Math.ceil(this.filteredTotal / this.itemsPerPage)
            },

        }

    }

</script>
